module.exports = __webpack_public_path__ + "static/media/knc.db1e9982.svg";